import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';
import constant from '../../../../config/constants';
import { withCart } from '../../../../utils/CartContext';
import { noop } from '../../../../utils/noop';
import { Badges } from '../../../Badges/Badges';
import { renderOOSView } from '../../common';
import { DeliveryOptionsModal } from '../../DeliveryOptions/DeliveryOptionsModal';
import DeliveryOptionsSelectedText from '../../DeliveryOptions/DeliveryOptionsSelectedText';
import { AvailabilityDesktopStyles } from '../AvailabilityDesktop/style';

const {
  // COOKIE_HOME_DELIVERY_KEY,
  // COOKIE_STORE_PICKUP_KEY,
  // LS_HOME_DELIVERY_KEY,
  // LS_STORE_PICKUP_KEY,
  // AVAILABILITY_HOMEDELIVERY,
  AVAILABILITY_OUTOFSTOCK,
  AVAILABILITY_ICON_CLASS_MAPPER,
} = constant;

const AvailabilityDesktopItem = ({
  appCtxData,
  availability,
  labelsData,
  isLast,
  hasModal,
  sizes,
  colorVariants,
  cart,
  availabilityList,
  deliveryData,
  deliveryActions,
  selectedType,
  setSelectedType,
  textGenerated,
  deliveryErrors,
  productData,
  variantData,
  shippingOptionType,
  zoneConfig,
  setZoneConfig,
  setSelectedDeliveryOption,
  selectedDeliveryOption,
  labelsKey,
  badges,
  comunaName,
}) => {
  const { stateOfStock } = availability;
  const { showShippingModal } = productData;
  const { regionCode } = appCtxData;

  const {
    // localStorageComunaKey,
    // localStorageRegionKey,
    // localStorageCiudadKey,
    // localAvailableTextDisplayKey,
    // subPrefix,
    outOfStock,
  } = labelsKey;

  const isOutOfStock = stateOfStock === AVAILABILITY_OUTOFSTOCK;

  // const [selectedCommuna, setSelectedCommuna] = useState();
  const [modalVisible, setModalVisible] = useState(false);

  // const { comuna, displayText } = useRegionComuna({
  //   modalVisible,
  //   lsComunaKey: localStorageComunaKey,
  //   lsRegionKey: localStorageRegionKey,
  //   lsCiudadKey: localStorageCiudadKey,
  //   displayKey: localAvailableTextDisplayKey,
  // });

  const persistedText = textGenerated[shippingOptionType];

  // useEffect(() => {
  //   setSelectedCommuna(
  //     getSelectedCommuna({
  //       shippingOptionType,
  //       AVAILABILITY_HOMEDELIVERY,
  //       COOKIE_HOME_DELIVERY_KEY,
  //       COOKIE_STORE_PICKUP_KEY,
  //       LS_HOME_DELIVERY_KEY,
  //       LS_STORE_PICKUP_KEY,
  //     })
  //   );
  // }, [shippingOptionType]);

  const { handleSetEntry, handleSetEntryGeoData } = deliveryActions;

  const handleItemClick = useCallback(() => {
    setModalVisible(true);
    setSelectedType(shippingOptionType);
    handleSetEntry(shippingOptionType);
    handleSetEntryGeoData({ ...zoneConfig, comunaName }, regionCode);
  }, [shippingOptionType, setSelectedType, handleSetEntry, handleSetEntryGeoData]);

  const getDeliveryModal = useCallback(() => {
    return (
      <DeliveryOptionsModal
        type={shippingOptionType}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        zoneConfig={zoneConfig}
        setZoneConfig={setZoneConfig}
        sizes={sizes}
        colorVariants={colorVariants}
        selectedDeliveryOption={selectedDeliveryOption}
        setSelectedDeliveryOption={setSelectedDeliveryOption}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        cart={cart}
        availabilityList={availabilityList}
        deliveryData={deliveryData}
        deliveryActions={deliveryActions}
        deliveryErrors={deliveryErrors}
        appCtxData={appCtxData}
        productData={productData}
        variantData={variantData}
        labelsData={labelsData}
        outOfStock={outOfStock}
      />
    );
  }, [
    shippingOptionType,
    modalVisible,
    setModalVisible,
    zoneConfig,
    setZoneConfig,
    sizes,
    colorVariants,
    selectedDeliveryOption,
    setSelectedDeliveryOption,
    selectedType,
    setSelectedType,
    cart,
    availabilityList,
    deliveryData,
    deliveryActions,
    deliveryErrors,
    appCtxData,
    productData,
    variantData,
    labelsData,
    outOfStock,
  ]);

  const shouldShowBadges = useMemo(() => {
    if (!modalVisible && badges && badges.length > 0 && selectedDeliveryOption) {
      const allKeysEmpty = Object.values(selectedDeliveryOption).every(
        (value) => !value || Object.keys(value).length === 0
      );
      return allKeysEmpty;
    }

    return false;
  }, [modalVisible, badges, selectedDeliveryOption]);

  return (
    <>
      <div>{hasModal && modalVisible && getDeliveryModal()}</div>

      <div
        className={`availability-item ${isLast && 'lastItem'} rebranded`}
        onKeyDown={noop}
        role="button"
        tabIndex={0}
        onClick={handleItemClick}
      >
        <div className={`icon ${AVAILABILITY_ICON_CLASS_MAPPER[shippingOptionType]}`} />

        <div className={`content ${isOutOfStock ? 'outofstock' : ''}`}>
          {!isOutOfStock
            ? showShippingModal && (
                <>
                  {/* {comuna.name && <span>{labelsData[`${subPrefix}`]} </span>} */}
                  <div id={`testId-Availability-Desktop-ModalOpen-${shippingOptionType}`}>
                    {persistedText && (
                      <DeliveryOptionsSelectedText
                        textData={persistedText}
                        labelsData={labelsData}
                        labelsKey={labelsKey}
                      />
                    )}
                  </div>
                </>
              )
            : renderOOSView({
                labelsData,
                outOfStock,
                comunaName,
                parentStateName: zoneConfig.parentStateName,
                styles: AvailabilityDesktopStyles,
              })}

          {shouldShowBadges && <Badges badgeItems={badges} deviceType="desktop" layout="PDP" />}
        </div>

        <style jsx>{AvailabilityDesktopStyles}</style>
      </div>
    </>
  );
};

AvailabilityDesktopItem.propTypes = {
  availability: PropTypes.object.isRequired,
  labelsData: PropTypes.object.isRequired,
  isLast: PropTypes.bool,
  hasModal: PropTypes.bool,
  sizes: PropTypes.array,
  colorVariants: PropTypes.array,
  cart: PropTypes.object.isRequired,
  availabilityList: PropTypes.array.isRequired,
  deliveryData: PropTypes.object,
  deliveryActions: PropTypes.object.isRequired,
  selectedType: PropTypes.string.isRequired,
  setSelectedType: PropTypes.func.isRequired,
  textGenerated: PropTypes.object.isRequired,
  showShippingModal: PropTypes.bool.isRequired,
  deliveryErrors: PropTypes.object,
  productData: PropTypes.object.isRequired,
  appCtxData: PropTypes.object.isRequired,
  variantData: PropTypes.object.isRequired,
  shippingOptionType: PropTypes.string.isRequired,
  zoneConfig: PropTypes.object.isRequired,
  setZoneConfig: PropTypes.func.isRequired,
  setSelectedDeliveryOption: PropTypes.func.isRequired,
  selectedDeliveryOption: PropTypes.object.isRequired,
  labelsKey: PropTypes.object.isRequired,
  badges: PropTypes.array,
  comunaName: PropTypes.string.isRequired,
};

AvailabilityDesktopItem.defaultProps = {
  isLast: false,
  hasModal: true,
  sizes: [],
  colorVariants: [],
  deliveryData: {},
  deliveryErrors: {
    PickupInStore: { isError: false, code: null },
    HomeDelivery: { isError: false, code: null },
    StockInStore: { isError: false, code: null },
  },
  badges: [],
};

export default withCart(AvailabilityDesktopItem);
